import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { CustomerSettingsList } from "./CustomerSettingsList";
import * as Screens from "src/screens";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Role } from "src/network/User";

interface Params {
    customerid: string;
}

const CustomerSettingsBase = () => {
    const { t } = useTranslation();
    const { customerid } = useParams<Params>();
    const { navStore, customerSettingsStore, authStore } = useContext(RootStoreContext);

    useEffect(() => {
        navStore.setTitle(t("customer_settings.title"));
        navStore.setBackbutton(`/customers/${customerid}`, t("common.customer"));
    }, [navStore, customerid, t]);

    useEffect(() => {
        customerSettingsStore.loadSettings(customerid);
    }, [customerSettingsStore, customerid]);

    if (customerSettingsStore.loading) return <Screens.Loading />;
    if (customerSettingsStore.loadError)
        return (
            <Screens.Error
                message={customerSettingsStore.loadError.message}
                networkError={customerSettingsStore.loadError.networkError}
            />
        );

    const canEditSettings = authStore.user?.role === Role.CUSTOMERDEV;

    return (
        <UI.Container className="pt-4">
            <UI.Row className="justify-content-md-center">
                <UI.Col md={12}>
                    <UI.Card>
                        <CustomerSettingsList
                            configurations={customerSettingsStore.settings}
                            listIdentifier={`customer-settings-${customerid}`}
                            canEdit={canEditSettings}
                        />
                    </UI.Card>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};

export default Sentry.withProfiler(observer(CustomerSettingsBase));
